import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../../../Services/shared.service';
import { API_End_Point } from '../../../../Services/API_End_Point';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { distinctUntilChanged, filter, take } from 'rxjs';
import { Router } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { FormBuilder } from '@angular/forms';
import { Cart } from '../../../../Services/Cart';
import { CartService } from '../../../../Services/cart.service';
import { PLATFORM_ID, Inject } from '@angular/core';



@Component({
  selector: 'app-plans',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './plans.component.html',
  styleUrl: './plans.component.css'
})
export class PlansComponent implements OnInit {
  PREP_UserInfo: any;
  classId: number | null = null;
  selectedSubject: string = '';
  All_PlanList: any[] = [];
  subjectClassMap: { [subject: string]: number[] } = {};
  availableSubjects: string[] = [];
  OrderNumber: any;
  addedItems: Set<number> = new Set();
  cartItems: Cart[] = [];
  ClassList: any = [];
  SubjectList: any = [];
  PlanList: any = [];
  IsShowMessage: boolean = false;
  constructor(
    public _svc: SharedService,
    private _router: Router,
    private _cart: CartService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this._svc.get_Login_Status().subscribe(x => {
      this.PREP_UserInfo = x;
    })
  }
  ngOnInit(): void {
    this._svc.get_Login_Status().pipe(distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)))
      .subscribe(x => {
        this.PREP_UserInfo = x;
        if (isPlatformBrowser(this.platformId)) {
          setTimeout(() => {
            this.loadAllPlans();
          });
        }
      });
    this._cart.cartItems().subscribe(items => {
      this.addedItems = new Set(items.map(item => item.bookId));
      this.cartItems = items;
    });


  }

  _buttonText(_obj: any): string {

    if (_obj.isPurchased) {
      return 'Purchased';
    } else if (this.addedItems.has(_obj.bookId)) {
      return 'Added ';
    } else if (_obj.isUpgrade) {
      return 'Upgrade @ Rs ' + _obj.price_New;
    }

    else return 'Add to cart';
  }

  loadAllPlans() {
    this.IsShowMessage = false;
    this._svc.GET(API_End_Point.MockTestPlan((this.PREP_UserInfo == null ? '' : this.PREP_UserInfo.userId))).subscribe((res: any) => {
      if (res.result === 'success') {

        this.All_PlanList = res.data;
        console.log(this.All_PlanList)
        this.ClassList = this._svc.uniqueBy(this.All_PlanList, 'className').sort((a: any, b: any) => Number(a.classId) - Number(b.classId));
        if (this.PREP_UserInfo?.classId > 0)
          this.classId = this.PREP_UserInfo.classId;
        else
          this.classId = this.ClassList[0].classId;

        this.Change_Class();
      } else {
        this.All_PlanList = [];
        this._svc.Notification('error', res.message || 'Unable to fetch plans.');

      }
    });
  }

  Change_Class() {

    var _temp = this.All_PlanList.filter(x => x.classId == this.classId)
    this.SubjectList = this._svc.uniqueBy(_temp, 'subjectName');
    if (this.SubjectList.length > 0)
      this.selectedSubject = this.SubjectList[0].subjectName;
    else
      this.IsShowMessage = true;

  }
  onSubjectChange(subject: string): void {
    this.selectedSubject = subject;
    //const classes = this.subjectClassMap[subject.toLowerCase()];
    //this.classId = classes?.[0] || null;
  }

  filterBySubject(subject: string): any[] {
    return this.All_PlanList.filter((plan: any) =>
      plan.subjectName === subject && plan.classId === this.classId
    );
  }

  AddNow(_obj: any): void {

    if (this.PREP_UserInfo == null) {
      this._router.navigateByUrl('/login?return=' + this._router.url);
    }

    else {
      var _index = this.cartItems.findIndex(x => x.classId == _obj.classId && x.subjectId == _obj.subjectId);
      if (_index > -1) {
        this._cart.remove(_index);
      }

      // if (this.cartItems.filter(x => x.classId == _obj.classId && x.subjectId == _obj.subjectId).length > 0) {
      //   this._svc.Notification('error', 'This plan is already added to your cart.');
      // }

      this._cart.add(
        new Cart(
          _obj.bookId,
          _obj.title,
          _obj.bookImage,
          'INR',
          1,
          (_obj.isUpgrade ? _obj.price_New : _obj.price),
          (_obj.isUpgrade ? 0 : _obj.discount),
          (_obj.isUpgrade ? 0 : _obj.price - _obj.priceAfterDiscount),
          _obj.gst,
          (_obj.isUpgrade ? _obj.gstAmount_New : _obj.gstAmount),
          _obj.bookType,
          _obj.plan,
          _obj.classId,
          _obj.subjectId
        )
      );

    }


  }
  getPlanMessage(planNumber: number): string {
    switch (planNumber) {
      case 1:
        return 'Helpful in providing a glimpse of Question Paper and gain confidence';
      case 2:
        return 'To gain pace in your Olympiad preparation';
      case 3:
        return 'Requires more time and extensive practice';
      case 4:
        return 'This exclusive pre-Olympiad package gives your child the winning edge before the final Olympiad exam. Build speed, sharpen accuracy and boost confidence with expert-designed practice questions.';
      case 5:
        return 'Combo pack features one test paper each for English, Maths and Science.Practise smarter, identify weak areas and get ready to perform your best across all three core subjects.';


      default:
        return '';
    }
  };

  getPlansubtitle(planTitle: number): string {
    switch (planTitle) {
      case 1:
        return 'Empower';
      case 2:
        return 'Elevate';
      case 3:
        return 'Thrive';
      case 5:
        return 'Aspire';
      default:
        return '';
    }
  }

  FrequentlyPurchased(planTitle: number): string {
    switch (planTitle) {
      case 1:
        return '';
      case 2:
        return 'Frequently Purchased';
      case 3:
        return '';
      default:
        return '';
    }
  }



}










